import React, { useState, useEffect } from "react";
import Api from "../Utills/Api";
import { motion } from "framer-motion";
import "./Profile.css";

const MyReferences = () => {
    const [references, setReferences] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const getReferences = async () => {
        try {
            setLoading(true);
            const response = await Api.get(`api/referrals/`);
            setReferences(response?.data?.data || []);
        } catch (err) {
            console.log("Error fetching references:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getReferences();
    }, []);

    const filteredReferences = references.filter((ref) =>
        ref.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        ref.phone_number.includes(searchQuery)
    );

    return (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
            padding: "20px",
            backgroundColor: "#f5f5f5",
            minHeight: "100vh",
            borderRadius: "12px",
        }}
    >
        <h2
            style={{
                color: "#5dc5fa",
                marginBottom: "24px",
                fontSize: "1.8rem",
                fontWeight: "bold",
            }}
        >
            My References
        </h2>

        {/* Search Bar */}
        <div style={{ marginBottom: "20px" }}>
            <input
                type="text"
                placeholder="Search by name or mobile number..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "1rem",
                    border: "2px solid #5dc5fa",
                    borderRadius: "8px",
                    outline: "none",
                    transition: "all 0.3s ease",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 4px rgba(241, 114, 40, 0.1)",
                }}
                onFocus={(e) => {
                    e.target.style.boxShadow =
                        "0 4px 12px rgba(241, 114, 40, 0.2)";
                }}
                onBlur={(e) => {
                    e.target.style.boxShadow =
                        "0 2px 4px rgba(241, 114, 40, 0.1)";
                }}
            />
        </div>

        {loading ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
                Loading references...
            </div>
        ) : filteredReferences.length === 0 ? (
            <div
                style={{
                    textAlign: "center",
                    padding: "40px",
                    background: "#fff",
                    borderRadius: "12px",
                    border: "2px dashed #ddd",
                }}
            >
                <div style={{ fontSize: "3rem", marginBottom: "12px" }}>🔍</div>
                <p style={{ color: "#999", fontSize: "1rem", marginBottom: "8px" }}>
                    {references.length === 0
                        ? "No references yet"
                        : "No matches found"}
                </p>
                <p style={{ color: "#bbb", fontSize: "0.9rem" }}>
                    {references.length === 0
                        ? "Share your referral link to start earning commissions!"
                        : "Try searching with different keywords"}
                </p>
            </div>
        ) : (
            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    border: "1px solid #f0f0f0",
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 200px)",
                    maxHeight: "750px",
                }}
            >
                {/* Table Header */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1.5fr 1fr 1fr",
                        gap: "16px",
                        padding: "16px 20px",
                        background: "linear-gradient(135deg, #fff7ed 0%, #fffbf5 100%)",
                        borderBottom: "2px solid #5dc5fa",
                        fontWeight: "600",
                        color: "#333",
                        fontSize: "0.9rem",
                        textTransform: "uppercase",
                        flexShrink: 0,
                        position: "sticky",
                        top: 0,
                    }}
                >
                    <div style={{ textAlign: "center" }}>Photo</div>
                    <div>Name</div>
                    {/* <div>Phone</div> */}
                    <div style={{ textAlign: "center" }}>Orders</div>
                </div>

                {/* Table Body - Scrollable */}
                <div
                    style={{
                        overflowY: "auto",
                        flex: 1,
                    }}
                >
                    {filteredReferences.map((ref, index) => (
                        <motion.div
                            key={ref.id || index}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.2, delay: index * 0.03 }}
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1.5fr 1fr 1fr",
                                gap: "16px",
                                padding: "16px 20px",
                                borderBottom: "1px solid #f0f0f0",
                                alignItems: "center",
                                transition: "background-color 0.2s ease",
                                cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#f9f9f9";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                            }}
                        >
                            {/* Profile Photo */}
                            <div style={{ textAlign: "center" }}>
                                <img
                                    src={ref.profile_photo || "/img/gallery/akash.jpeg"}
                                    alt="Profile"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "2px solid #5dc5fa",
                                    }}
                                />
                            </div>

                            {/* Name */}
                            <div>
                                <p
                                    style={{
                                        color: "#333",
                                        fontSize: "0.95rem",
                                        fontWeight: "500",
                                        margin: 0,
                                    }}
                                >
                                    {ref.name || "User"}
                                </p>
                            </div>

                            {/* Phone Number */}
                            {/* <div>
                                <p
                                    style={{
                                        color: "#666",
                                        fontSize: "0.9rem",
                                        margin: 0,
                                    }}
                                >
                                    {ref.phone_number || "N/A"}
                                </p>
                            </div> */}

                            {/* Order Count */}
                            <div style={{ textAlign: "center" }}>
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #fff7ed 0%, #fffbf5 100%)",
                                        border: "1px solid #5dc5fa",
                                        borderRadius: "6px",
                                        padding: "6px 12px",
                                        fontSize: "0.95rem",
                                        fontWeight: "600",
                                        color: "#5dc5fa",
                                    }}
                                >
                                    {ref.order_count || 0}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        )}
    </motion.div>
  );
};

export default MyReferences;
